// @core/api/endpoints/calendar/check_entity_availability.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckEntityAvailabilityRequest,
  CheckEntityAvailabilityResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Check entity availability
 * Checks if the requested time slot is available for a calendar-aware entity type, considering the type's booking rules (min_notice, max_days_ahead, buffer times) and participant availability.
 */
export async function CheckEntityAvailability(
  target_type: string,
  data: CheckEntityAvailabilityRequest,
  options?: RequestOptions
): Promise<CheckEntityAvailabilityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:target_type/check-availability`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  const requestOptions = options;
  return client.post<CheckEntityAvailabilityResponse>(requestPath, data, requestOptions);
}
